var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"d-flex",attrs:{"cols":"12","sm":"12"}},[_c('v-select',{attrs:{"label":"IP Version","items":_vm.list,"return-object":false}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }